import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/behance': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M232 237.2C263.8 222 280.4 199 280.4 163.2 280.4 92.6 227.8 75.4 167.1 75.4H0V429.8H171.8C236.2 429.8 296.7 398.9 296.7 326.9 296.7 282.4 275.6 249.5 232 237.2zM77.9 135.9H151C179.1 135.9 204.4 143.8 204.4 176.4 204.4 206.5 184.7 218.6 156.9 218.6H77.9V135.9zM161.2 369.6H77.9V272H162.8C197.1 272 218.8 286.3 218.8 322.6 218.8 358.4 192.9 369.6 161.2 369.6zM519.7 128.9H376V94H519.7V128.9zM576 305.2C576 229.3 531.6 166 451.1 166 372.9 166 319.8 224.8 319.8 301.8 319.8 381.7 370.1 436.5 451.1 436.5 512.4 436.5 552.1 408.9 571.2 350.2H509C502.3 372.1 474.7 383.7 453.3 383.7 412 383.7 390.3 359.5 390.3 318.4H575.4C575.7 314.2 576 309.7 576 305.2zM390.4 274C392.7 240.3 415.1 219.2 448.9 219.2 484.3 219.2 502.1 240 505.1 274H390.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/behance.js
// module id = L5VL
// module chunks = 144